/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import MaterialTable from "material-table";
import AddNewRemitterModal from "./AddNewRemitterModal";
import RemitterNavbar from "./RemitterNavbar";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  checkKycStatus,
  deleteRemitter,
  remitterSignUp,
  resendKycLink,
  sendOtp,
  userRegistrationDetails,
  validateOtp,
} from "../../services/remitter";
import { getKycStatusFromIdfy } from "../../utils";
import { panDeclaration, transactionDetails } from "../../store";
import { IRemitterProps } from "./Remmiter";
import { ArrowDownChevy, ArrowRightChevy, Minus, Plus, RemitterBanner } from "../../assets/Icons";
import Typograpy from "../../components/ui/Typography";
import Button from "../../components/ui/Button";
import Radio from "../../components/ui/Radio";
import RemitterDetails from "./RemitterDetails";
import Loader from "../../components/ui/Loader";
import Pagination from "../../components/ui/Pagination";
import KycStatus from "../../components/ui/KycStatus";
import Toast from "../../components/ui/Toast";
import TableWithDetailPanel from "../../components/ui/Table";

declare global {
  interface Window {
    fbq?: any;
    gtag?: any;
    ir?: any;
  }
}

const Remitter = () => {
  const navigate = useNavigate();
  const [remitterData, setRemitterData] = React.useState([{} as IRemitterProps.remitterData]);
  const [datFetchFailure, setDatFetchFailure] = React.useState<boolean>(false);
  const [addRemmitterModal, setAddRemitterModal] = React.useState<boolean>(false);
  const [isMobileVerified, setIsMobileVerified] = React.useState<boolean>(false);
  const [isOtpSend, setIsOtpSend] = React.useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = React.useState<string>("");
  const [isAgree, setIsAgree] = React.useState<number>(0);
  const [date, saveDate] = React.useState(Date.now());
  const [dateKey, saveDateKey] = React.useState(0);
  const [formData, setFormData] = React.useState({
    email: "",
    mobileNumber: "",
    otpValue: "",
  });
  const [otpError, setOTPError] = React.useState<string>("");
  const [panMismatchError, setPanMismatchError] = React.useState<boolean>(false);
  const panDeclarationValue = useRecoilValue(panDeclaration);
  const [signUpError, setSignUpError] = React.useState(
    {} as IRemitterProps.addNewRemitterSignUpError
  );
  const [otpType, setOtpType] = React.useState<string>("");
  const [selectedRemitter, setSelectedRemitter] = React.useState<any>({});
  const [fetchedKycStatus, setFetchedKycStatus] = React.useState<string>("");
  const [searchedInput, setSearchedInput] = React.useState<string>("");
  const isUseEffectFired = React.useRef(false);
  const [transactionData, setTransactionData] = useRecoilState(transactionDetails);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [isSendLink, setIsSendLink] = React.useState(false);
  const [isOtpDisabled, setIsOtpDisabled] = React.useState(true);
  const [otpLoading, setOtpLoading] = React.useState(false);
  const [isDisabled, setIsDisabled] = React.useState(false);
  const [buttonLoader, setButtonLoader] = React.useState(false);
  const [unsavedChanges, setUnsavedChanges] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [pendingNavigation, setPendingNavigation] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState<number | any>();
  const [remitterInfo, setRemitterInfo] = React.useState<IRemitterProps.remitterData | undefined>();
  const [catchKycLink, setCatchKycLink] = useState<any>("");
  const [sendKycLink, setSendKycLink] = useState<any>("");
  const [pagination, setPagination] = React.useState({
    page: 0,
    size: 10,
    ascending: false,
    totalElements: 0,
    totalPages: 0,
  });
  const { pathname } = useLocation();
  const [kyctoast, setKycToast] = useState<{
    message: string;
    type: "success" | "failure";
  } | null>(null);
  const [collapseTrigger, setCollapseTrigger] = useState(false);

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      event.preventDefault();
      sessionStorage.setItem("navigatingFromPage", "true");
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    getRegistrationDetails();
  }, [pagination.size, pagination.page]);

  useEffect(() => {
    setTimeout(() => {
      const shouldNavigate = sessionStorage.getItem("navigatingFromPage") === "true";
      if (shouldNavigate) {
        sessionStorage.removeItem("navigatingFromPage");
        navigate("/remittance", { replace: true });
      }
    }, 500);
  }, [navigate]);

  // useEffect(() => {
  //   getRegistrationDetails();
  // }, [pagination]);

  const showToast = (message: string, type: "success" | "failure") => {
    setKycToast({ message, type });
  };

  const handleCloseToast = () => {
    setKycToast(null);
  };

  const handleMobileVerification = (apiType: string, otpType: string) => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

    const commonBody = {
      phoneNumber: formData?.mobileNumber,
      otpType: otpType,
    };

    setOtpLoading(true);
    setOtpType(otpType);
    sendOtp({
      body:
        apiType === "resend"
          ? { ...commonBody }
          : {
              ...commonBody,
              actionType: "REMITTER_SIGN_UP",
              userId: currentUser?.vendor_key,
            },
      apiType: apiType,
    })
      .then((response) => {
        if (response.data.success) {
          setIsOtpSend(true);
          saveDate(Date.now() + 60000);
          saveDateKey(dateKey + 1);
          setIsOtpDisabled(false);
        } else {
          setIsOtpSend(false);
          setSignUpError({ mobile: response.data.message, email: "" });
        }
      })
      .catch((error) => {
        setIsOtpSend(false);
        setSignUpError({
          mobile: error?.response?.data?.error?.type,
          email: "",
        });
      })
      .finally(() => setOtpLoading(false));
  };

  const handleResendLink = (number: any) => {
    setIsDisabled(true);
    const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

    const commonBody = {
      phoneNumber: number,
      otpType: "link",
      actionType: "REMITTER_SIGN_UP",
      userId: currentUser?.vendor_key,
      getLinkResend: true,
    };

    setOtpType(otpType);
    sendOtp({
      body: commonBody,
      apiType: "send",
    })
      .then((response) => {
        if (response.data.success) {
          saveDate(Date.now() + 60000);
          saveDateKey(dateKey + 1);
          // toast.success("Link sent successfully to remitter's mobile number");
          showToast(
            "KYC Link sent successfully to email and phone number of the remitter",
            "success"
          );
          setIsModalOpen("");
        } else {
          setIsOtpSend(false);
          // toast.success("Failed to send link");
          showToast("Failed to send link", "failure");
        }
      })
      .catch((error) => {
        setIsOtpSend(false);
        setSignUpError({
          mobile: error?.response?.data?.error?.type,
          email: "",
        });
      })
      .finally(() => setIsDisabled(false));
  };

  const handleLinkVerification = (apiType: string, otpType: string) => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

    const commonBody = {
      phoneNumber: formData?.mobileNumber,
      otpType: otpType,
    };
    setOtpType(otpType);
    if (apiType === "skip") {
      remitterSignUp({
        email: formData.email,
        is_email_verified: true,
        is_phone_verified: true,
        phoneNumber: formData.mobileNumber.replace(/[^\d\+]/g, ""),
      })
        .then((response) => {
          localStorage.setItem("vendorUserKey", response?.data?.user_key);
          localStorage.setItem("userRemitterId", response.data.id);
          // toast.success("Remitter added successfully");
          showToast("Remitter added successfully", "success");

          setAddRemitterModal(false);
          setFormData({ email: "", mobileNumber: "", otpValue: "" });
          setIsSendLink(false);
          navigate("/user-documents");
          window?.fbq("track", "CompleteRegistration", {
            content_name: "registration remit signup",
          });

          window?.gtag("event", "click", {
            event_category: "Sign Up on HopRemit",
            event_label: "Click on SignUp",
            event_action: "Signup button on moneytransfer.moneyhop.co",
          });

          window?.gtag("event", "conversion", {
            send_to: "AW-618228521/6wB8CKTZ6u8BEKnW5aYC",
          });
        })
        .catch((err) => {
          setSignUpError({
            email: err?.response?.data?.error?.type,
            mobile: "",
          });
        })
        .finally(() => setOtpLoading(false));
    } else if (apiType === "send") {
      setOtpLoading(true);
      remitterSignUp({
        email: formData.email,
        is_email_verified: true,
        is_phone_verified: true,
        phoneNumber: formData.mobileNumber.replace(/[^\d\+]/g, ""),
      })
        .then((response) => {
          localStorage.setItem("vendorUserKey", response?.data?.user_key);
          localStorage.setItem("userRemitterId", response?.data?.id);
          // toast.success("Remitter added successfully");
          showToast("Remitter added successfully", "success");
          handleResendKycLink(response?.data?.user_key);
          showToast(
            "KYC Link sent successfully to email and phone number of the remitter",
            "success"
          );
          setAddRemitterModal(false);
          setFormData({ email: "", mobileNumber: "", otpValue: "" });
          setIsSendLink(false);
        })
        .catch((err) => {
          setSignUpError({
            email: err?.response?.data?.error?.type,
            mobile: "",
          });
        })
        .finally(() => setOtpLoading(false));
    } else {
      setOtpLoading(true);
      sendOtp({
        body:
          apiType === "resend"
            ? { ...commonBody }
            : {
                ...commonBody,
                actionType: "REMITTER_SIGN_UP",
                userId: currentUser?.vendor_key,
              },
        apiType: apiType,
      })
        .then((resp) => {
          if (!resp.data.success) {
            // toast.error("Failed to send link");
            showToast("Failed to send link", "failure");
            setIsModalOpen("");
          } else {
            // toast.success("Link sent successfully to remitter's mobile number");
            showToast(
              "KYC Link sent successfully to email and phone number of the remitter",
              "success"
            );
            setIsModalOpen("");
            remitterSignUp({
              email: formData.email,
              is_email_verified: true,
              is_phone_verified: false,
              // eslint-disable-next-line
              phoneNumber: formData.mobileNumber.replace(/[^\d\+]/g, ""),
            })
              .then((response) => {
                localStorage.setItem("vendorUserKey", response?.data?.user_key);
                localStorage.setItem("userRemitterId", response?.data?.id);
                // toast.success("Remitter added successfully");
                showToast("Remitter added successfully", "success");
                setAddRemitterModal(false);
                setFormData({ email: "", mobileNumber: "", otpValue: "" });
                setIsSendLink(false);
                handleRefresh();
                window?.fbq("track", "CompleteRegistration", {
                  content_name: "registration remit signup",
                });

                window?.gtag("event", "click", {
                  event_category: "Sign Up on HopRemit",
                  event_label: "Click on SignUp",
                  event_action: "Signup button on moneytransfer.moneyhop.co",
                });

                window?.gtag("event", "conversion", {
                  send_to: "AW-618228521/6wB8CKTZ6u8BEKnW5aYC",
                });
              })
              .catch((err) => {
                if (err?.response?.data?.status === 500) {
                  setSignUpError({
                    email: "The user is already registered, if not please try after sometime.",
                    mobile: "",
                  });
                } else if (
                  err?.response?.data?.error.type ===
                  "Mobile number already registered with you, Please use different number"
                ) {
                  if (err?.response !== undefined) {
                    setSignUpError({
                      mobile: err.response.data.error.type,
                      email: "",
                    });
                    setIsMobileVerified(false);
                  }
                } else if (
                  err?.response?.data?.error?.type ===
                  "Email already registered for you, Please use different email"
                ) {
                  if (err?.response !== undefined) {
                    setSignUpError({
                      email: err.response.data.error.type,
                      mobile: "",
                    });
                  }
                }
              })
              .finally(() => setOtpLoading(false));
          }
        })
        .catch((error) => {
          setIsOtpSend(false);
          setIsSendLink(false);
          setSignUpError({
            mobile: error?.response?.data?.error?.type,
            email: "",
          });
        })
        .finally(() => setOtpLoading(false));
    }
  };

  const onSubmit = (values: { email: string; mobileNumber: string; otp: string }) => {
    setOtpLoading(true);
    validateOtp({
      email_phone: formData?.mobileNumber,
      otp: formData?.otpValue,
      otpType: otpType,
    })
      .then((response: any) => {
        if (response?.data?.success) {
          setIsMobileVerified(true);
          setOTPError("");
          remitterSignUp({
            email: values.email,
            is_email_verified: true, //true
            is_phone_verified: true, //false
            // eslint-disable-next-line
            phoneNumber: values.mobileNumber.replace(/[^\d\+]/g, ""),
          })
            .then((response) => {
              localStorage.setItem("vendorUserKey", response?.data?.user_key);
              localStorage.setItem("userRemitterId", response?.data?.id);
              navigate("/user-documents");
              setAddRemitterModal(false);
              window?.fbq("track", "CompleteRegistration", {
                content_name: "registration remit signup",
              });

              window?.gtag("event", "click", {
                event_category: "Sign Up on HopRemit",
                event_label: "Click on SignUp",
                event_action: "Signup button on moneytransfer.moneyhop.co",
              });

              window?.gtag("event", "conversion", {
                send_to: "AW-618228521/6wB8CKTZ6u8BEKnW5aYC",
              });

              window?.ir("track", {
                orderID: values.email,
                event: "register",
                email: values.email,
                fname: "",
                // eslint-disable-next-line
                mobile: values.mobileNumber.replace(/[^\d\+]/g, ""),
              });
            })
            .catch((err) => {
              if (err?.response?.data?.status === 500) {
                setSignUpError({
                  email: "The user is already registered, if not please try after sometime.",
                  mobile: "",
                });
              } else if (
                err?.response?.data?.error.type ===
                "Mobile number already registered with you, Please use different number"
              ) {
                if (err?.response !== undefined) {
                  setSignUpError({
                    mobile: err.response.data.error.type,
                    email: "",
                  });
                  setIsMobileVerified(false);
                }
              } else if (
                err?.response?.data?.error?.type ===
                "Email already registered for you, Please use different email"
              ) {
                if (err?.response !== undefined) {
                  setSignUpError({
                    email: err.response.data.error.type,
                    mobile: "",
                  });
                }
              } else if (err?.response?.data?.status === 422) {
                setSignUpError({
                  email: "Invalid email id",
                  mobile: "",
                });
              }
            });
        } else {
          setOTPError("Incorrect Verification code, please try again.");
        }
      })
      .catch((error) => {
        setOTPError(error.response.data.error.type);
      })
      .finally(() => {
        setOtpLoading(false);
      });
  };

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      if (unsavedChanges) {
        event.preventDefault();
        event.returnValue = ""; // For some browsers
        return "Are you sure you want to refresh? All your saved data will be lost.";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [unsavedChanges]);

  const handleConfirmedRemitterDelete = () => {
    setLoading(true);
    deleteRemitter(selectedRemitter?.userKey)
      .then((res) => {
        if (res) {
          const tempData = remitterData.filter(
            (item) => item.userKey !== selectedRemitter?.userKey
          );
          setRemitterData(tempData);
          setIsModalOpen("");
          handleRefresh();
          showToast("Remitter deleted successfully", "success");
        } else {
          console.error("Unexpected response while deleting remitter", res);
          // toast.error("Failed to delete remitter.");
          showToast("Failed to delete remitter", "failure");
        }
      })
      .catch((error) => {
        console.error("Error while deleting remitter:", error);
        console.error("Error response:", error.response);
        console.error("Error data:", error.response?.data);

        const errorType = error?.response?.data?.error?.type;
        // toast.error(errorType || "Failed to delete remitter.");
        showToast(errorType || "Failed to delete remitter.", "failure");
      })
      .finally(() => setLoading(false));
  };

  const handleCheckKycStatus = (SelectedId: number) => {
    setIsDisabled(true);
    const selectedRemitterData = remitterData.filter(
      (data: { id: number }) => data?.id == SelectedId
    )[0];
    setSelectedRemitter(selectedRemitterData);

    checkKycStatus(SelectedId)
      .then((response: any) => {
        return setFetchedKycStatus(
          getKycStatusFromIdfy(response?.data?.profileStatus?.toLowerCase())
        );
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => setIsDisabled(false));
  };

  const handleResendKycLink = (id: string) => {
    setIsDisabled(true);
    resendKycLink(id)
      .then((res) => {
        const newLink = res?.data?.link;
        if (newLink) {
          setCatchKycLink((prevState: any) => {
            return newLink;
          });
        }
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error("Error:", err);
      })
      .finally(() => setIsDisabled(false));
  };

  const handleRadioEvent = (selectedId: number | undefined) => {
    if (selectedId !== undefined) {
      setIsModalOpen("confirmSelectedRemitter");
      setIsAgree((preValues) => (preValues === Number(selectedId) ? 0 : Number(selectedId)));
      const selectedRemitterData = remitterData?.filter((data) => data?.id == selectedId)[0];
      if (panDeclarationValue !== "" && selectedRemitterData?.panNumber !== "") {
        if (panDeclarationValue !== selectedRemitterData?.panNumber) {
          setPanMismatchError(true);
        } else {
          setPanMismatchError(false);
        }
      } else {
        setPanMismatchError(false);
      }

      setSelectedRemitter(selectedRemitterData);
      localStorage.setItem("vendorUserKey", selectedRemitterData?.userKey);
      localStorage.setItem("vendorUserDetails", JSON.stringify(selectedRemitterData));
      localStorage.setItem("userRemitterId", String(selectedRemitterData?.id));
    }
  };

  const handleTransactionUpdate = async () => {
    localStorage.setItem("vendorUserDetails", JSON.stringify(selectedRemitter));
    localStorage.setItem("vendorUserKey", selectedRemitter?.userKey);
    localStorage.setItem("userRemitterId", String(selectedRemitter?.id));
    localStorage.setItem("fromSendMoney", JSON.stringify(true));
    const local_transaction = {
      user_send: transactionData?.user_send,
      reciepient_recieve: transactionData?.reciepient_recieve,
      dest_currency: transactionData?.dest_currency,
      hop_coins: transactionData?.hop_coins,
      mgr_initial: transactionData?.mgr_initial,
      promo_code: transactionData?.promo_code,
      conversion_rate: transactionData?.conversion_rate,
    };
    setTransactionData({ ...transactionData, ...local_transaction });

    if (panMismatchError) {
      setIsModalOpen("");
    } else {
      if (!selectedRemitter?.isDocVerified) {
        navigate("/user-documents");
      } else if (
        selectedRemitter?.gender === null ||
        selectedRemitter?.nationality === null ||
        selectedRemitter?.gender === "" ||
        selectedRemitter?.nationality === "" ||
        selectedRemitter?.employmentStatus === null ||
        selectedRemitter?.industryType === null ||
        selectedRemitter?.employmentStatus === "" ||
        selectedRemitter?.industryType === ""
      ) {
        navigate("/user-details");
      } else {
        navigate("/pick-recipient");
      }
    }
  };

  const selectRemitterHandler = (SelectedId: number) => {
    localStorage.setItem("remitter_key", String(SelectedId));
    const selectedRemitterData = remitterData.find(
      (data: { id: number; panNumber: any }) => data?.id == SelectedId
    );
    localStorage.setItem("remitterName", selectedRemitterData?.firstName ?? "");
    if (
      selectedRemitterData?.panNumber !== panDeclarationValue &&
      panDeclarationValue !== "" &&
      selectedRemitterData?.panNumber !== null
    ) {
      setKycToast({
        message: "Please select Remitter with PAN similar to declared in Declaration Modal",
        type: "failure",
      });
      return;
    }
    if (selectedRemitterData || panDeclarationValue === "") {
      setSelectedRemitter(selectedRemitterData);
      // setIsModalOpen("confirmSelectedRemitter");
    }
  };

  const deleteRemitterHandler = (SelectedId: number) => {
    const selectedRemitterData = remitterData.filter(
      (data: { id: number }) => data?.id == SelectedId
    )[0];
    setSelectedRemitter(selectedRemitterData);
    setIsModalOpen("confirmDeleteRemitter");
  };
  const UserKey = localStorage.getItem("userKey") || "";
  const getRegistrationDetails = () => {
    setLoading(true);
    setDatFetchFailure(false);
    const body = {
      UserKey,
      page: pagination.page,
      size: pagination.size === 0 ? 10 : pagination.size,
      ascending: pagination.ascending,
      filter: searchedInput,
    };
    userRegistrationDetails(body)
      .then((response) => {
        const tempData = response.data.content.filter(
          (item: { typeOfRemitter: string; panNumber?: string }) =>
            item.typeOfRemitter === "Online" &&
            (panDeclarationValue === "" || item.panNumber === panDeclarationValue)
        );
        setRemitterData(tempData);
        setPagination((prevData) => ({
          ...prevData,
          totalElements: response?.data?.totalElements,
          totalPages: response?.data?.totalPages,
          size: response?.data?.size,
        }));
      })
      .catch((error) => {
        setRemitterData([]);
        setDatFetchFailure(true);
      })
      .finally(() => setLoading(false));
  };

  const handleSelectedRemitter = (SelectedId: number) => {
    const selectedRemitterData = remitterData.filter(
      (data: { id: number }) => data?.id == SelectedId
    )[0];
    setSelectedRemitter(selectedRemitterData);
  };

  const handleAddNewRemitterModalClose = () => {
    setFormData({
      email: "",
      mobileNumber: "",
      otpValue: "",
    });
    setSignUpError({ email: "", mobile: "" });
    setAddRemitterModal(false);
    setIsOtpSend(false);
  };

  const addRemitterOnChangeHandler = (value: string, fieldType: string) => {
    return (
      signUpError?.email !== "" && fieldType === "email"
        ? (saveDate(Date.now()),
          setFormData((preValue) => {
            return { ...preValue, ["otpValue"]: "" };
          }),
          setSignUpError({ email: "", mobile: "" }))
        : null,
      signUpError?.mobile !== "" && fieldType === "mobileNumber"
        ? (setIsOtpSend(false),
          setFormData((preValue) => {
            return { ...preValue, ["otpValue"]: "" };
          }),
          setSignUpError({ email: "", mobile: "" }))
        : null,
      setFormData((preValue) => {
        return { ...preValue, [fieldType]: value };
      })
    );
  };

  React.useEffect(() => {
    setLoading(true);
    setDatFetchFailure(false);
    if (!isUseEffectFired.current) {
      isUseEffectFired.current = true;
      const body = {
        UserKey,
        page: pagination.page,
        size: pagination.size,
        ascending: pagination.ascending,
        filter: searchedInput,
      };
      userRegistrationDetails(body)
        .then((response) => {
          const tempData = response.data.content.filter(
            (item: { typeOfRemitter: string; panNumber?: string }) =>
              item.typeOfRemitter === "Online" &&
              (panDeclarationValue === "" || item.panNumber === panDeclarationValue)
          );
          setPagination((prevData) => ({
            ...prevData,
            totalElements: response?.data?.totalElements,
            totalPages: response?.data?.totalPages,
            size: response?.data?.size,
          }));
          setRemitterData(tempData);
        })
        .catch((error) => {
          setRemitterData([]);
          setDatFetchFailure(true);
        })
        .finally(() => setLoading(false));
    }
  }, []);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      getRegistrationDetails();
    }, 200);

    return () => clearTimeout(timer);
  }, [searchedInput]);

  useEffect(() => {
    return () => {
      setSearchedInput("");
    };
  }, [setSearchedInput]);

  useEffect(() => {
    return () => {
      setSearchedInput("");
    };
  }, [pathname, setSearchedInput]);

  React.useEffect(() => {
    isModalOpen === "" && setIsAgree(0);
  }, [isModalOpen]);

  const handleRefresh = () => {
    setLoading(true);
    setIsDisabled(true);
    setDatFetchFailure(false);
    const body = {
      UserKey,
      page: pagination.page,
      size: pagination.size,
      ascending: pagination.ascending,
      filter: searchedInput,
    };
    userRegistrationDetails(body)
      .then((response) => {
        const tempData = response.data.content.filter(
          (item: { typeOfRemitter: string; panNumber?: string }) =>
            item.typeOfRemitter === "Online" &&
            (panDeclarationValue === "" || item.panNumber === panDeclarationValue)
        );
        setPagination((prevData) => ({
          ...prevData,
          totalElements: response?.data?.totalElements,
          totalPages: response?.data?.totalPages,
          size: response?.data?.size,
        }));
        setRemitterData(tempData);
      })
      .catch((error) => {
        setRemitterData([]);
        setDatFetchFailure(true);
      })
      .finally(() => {
        setLoading(false);
        setIsDisabled(false);
      });
  };

  return (
    <>
      <div className="max-w-[1440px] w-full mx-auto px-[160px]">
        {loading && <Loader />}
        <ToastContainer autoClose={3000} position="top-right" />
        {kyctoast && (
          <Toast message={kyctoast?.message} type={kyctoast?.type} onClose={handleCloseToast} />
        )}
        {/* Navbar Section */}
        <RemitterNavbar
          setAddRemitterModal={setAddRemitterModal}
          setSearchedInput={(val) => {
            setSearchedInput(val);
            setCollapseTrigger((prev) => !prev); // trigger collapse when input changes
          }}
          searchedInput={searchedInput}
          handleRefresh={handleRefresh}
        />
        {/* Table Section */}
        <TableWithDetailPanel
          data={remitterData}
          deleteRemitterHandler={deleteRemitterHandler}
          handleTransactionUpdate={handleTransactionUpdate}
          handleSelectedRemitter={handleSelectedRemitter}
          handleResendKycLink={handleResendKycLink}
          handleResendLink={handleResendLink}
          catchKycLink={catchKycLink}
          showToast={showToast}
          datFetchFailure={datFetchFailure}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          setRemitterInfo={setRemitterInfo}
          selectRemitterHandler={selectRemitterHandler}
          selectedRemitter={selectedRemitter}
          setSelectedRemitter={setSelectedRemitter}
          collapseTrigger={collapseTrigger}
        />
        <Pagination
          pageSize={pagination.size}
          setPagination={setPagination}
          currentPage={pagination.page}
          totalItems={pagination.totalElements}
          pagination={pagination}
        />
      </div>

      {/* Add New Remmiter Modal */}
      <AddNewRemitterModal
        addRemmitterModal={addRemmitterModal}
        isMobileVerified={isMobileVerified}
        setIsMobileVerified={setIsMobileVerified}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        handleMobileVerification={handleMobileVerification}
        handleLinkVerification={handleLinkVerification}
        dateKey={dateKey}
        date={date}
        otpLoading={otpLoading}
        onSubmit={onSubmit}
        otpError={otpError}
        isOtpSend={isOtpSend}
        signUpError={signUpError}
        selectedRemitter={selectedRemitter}
        handleTransactionUpdate={handleTransactionUpdate}
        handleConfirmedRemitterDelete={handleConfirmedRemitterDelete}
        handleAddNewRemitterModalClose={handleAddNewRemitterModalClose}
        addRemitterOnChangeHandler={addRemitterOnChangeHandler}
        formData={formData}
        isSendLink={isSendLink}
        setIsSendLink={setIsSendLink}
        isOtpDisabled={isOtpDisabled}
        panMismatchError={panMismatchError}
        handleResendKycLink={handleResendKycLink}
        selectRemitterHandler={selectRemitterHandler}
      />
    </>
  );
};

export default Remitter;
